import { render } from "./FridgeSettingsTimePage.vue?vue&type=template&id=83adcb16&scoped=true&ts=true"
import script from "./FridgeSettingsTimePage.vue?vue&type=script&lang=ts"
export * from "./FridgeSettingsTimePage.vue?vue&type=script&lang=ts"

import "./FridgeSettingsTimePage.vue?vue&type=style&index=0&id=83adcb16&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83adcb16"]])

export default __exports__